import React from 'react';
import { useSelector } from 'react-redux';

const ErrorPage = () => {
    const { userDetails } = useSelector((state) => state.user);
    const { is_admin = true } = userDetails;

    return (
        <div>
            <h1 className={is_admin === false ? 'gray-900' : '' }>Access Denied</h1>
            <p className={is_admin === false ? 'gray-900' : '' }>Sorry, you don't have access to view this page.</p>
        </div>
    );
};

export default ErrorPage;
